import { CheckCircleOutline, AlertOutline } from 'mdi-material-ui';

import { Chip } from './Chip';

export type ExclusionChipProps = {
	exclusionCodeCount: number;
	dataTestId?: string;
};

// Component for displaying an exclusion chip with a count and appropriate icon based on the exclusion status.

export const ExclusionChip = (props: ExclusionChipProps) => {
	const { exclusionCodeCount, dataTestId } = props;
	return (
		<Chip
			name='Exclusion'
			value={`${exclusionCodeCount}`}
			style={exclusionCodeCount > 0 ? 'hasExclusions' : 'noExclusions'}
			className='inline-block py-1!'
			dataTestId={dataTestId ?? 'exclusion-chip'}
			icon={
				exclusionCodeCount > 0 ? (
					<AlertOutline
						className='text-hasExclusionsText'
						sx={{ width: '20px', height: 'auto' }}
						aria-hidden='true'
					/>
				) : (
					<CheckCircleOutline
						className='text-noExclusionsText'
						sx={{ width: '20px', height: 'auto' }}
						aria-hidden='true'
					/>
				)
			}
		/>
	);
};
